import React from "react"
import "./blackFriday2026.scss"

/**
 * Black Friday product badge (black "BLACK FRIDAY" + red discount chip),
 * on the product image. Without a known discount it shows the wording only.
 */
const BfTag = ({ discount, size = "md", className = "" }) => (
  <span className={`bf-tag bf-tag--${size} ${discount ? "bf-tag--discount" : ""} ${className}`}>
    <i className="bf-tag__slash" />
    <span className="bf-tag__text">
      Black<b>Friday</b>
    </span>
    {discount ? <span className="bf-tag__discount">-{discount}%</span> : null}
  </span>
)

export default BfTag
